import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('DailyForAWeek')
export default class DailyForAWeek {

  @JsonProperty('date', String, false) // Third parameter (optional): isOptional
  public date: string
  @JsonProperty('value', Number, false)
  public value: number

  constructor(
        date: string,
        value: number,
        ) {
    this.date = date
    this.value = value
  }
}
